import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, Footer } from '../components';
import { addContact } from '../lib/api/contactApi';

const SUPPORT_EMAIL = 'support@keepmygames.com';
const EMPTY = { nom: '', mail: '', sujet: '', message: '' };

function ContactPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState(null); // 'ok' | 'error' | null
  const [busy, setBusy] = useState(false);

  const field = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    try {
      await addContact(form);
      setStatus('ok');
      setForm(EMPTY);
    } catch {
      setStatus('error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Header />
      <main className="contact">
        <a className="contact__back" href="/">
          {t('contact.back')}
        </a>
        <h1 className="contact__title">{t('contact.title')}</h1>
        <p className="contact__subtitle">{t('contact.subtitle')}</p>
        <p className="contact__mail">
          {t('contact.direct')}{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </p>

        {status === 'ok' ? (
          <div className="contact__flash contact__flash--ok">{t('contact.success')}</div>
        ) : (
          <form className="contact__form" onSubmit={submit}>
            {status === 'error' && (
              <div className="contact__flash contact__flash--err">{t('contact.error')}</div>
            )}
            <label className="contact__label">
              {t('contact.name')}
              <input
                type="text"
                value={form.nom}
                onChange={field('nom')}
                required
                autoComplete="name"
              />
            </label>
            <label className="contact__label">
              {t('contact.email')}
              <input
                type="email"
                value={form.mail}
                onChange={field('mail')}
                required
                autoComplete="email"
              />
            </label>
            <label className="contact__label">
              {t('contact.subject')}
              <input type="text" value={form.sujet} onChange={field('sujet')} required />
            </label>
            <label className="contact__label">
              {t('contact.message')}
              <textarea rows="6" value={form.message} onChange={field('message')} required />
            </label>
            <button type="submit" className="btn btn--amber contact__send" disabled={busy}>
              {busy ? '…' : t('contact.send')}
            </button>
          </form>
        )}
      </main>
      <Footer />
    </>
  );
}

export default ContactPage;
